
    <kv-datatable
    [allowsMultiSelection]="false"
    id="dt_classification_types"
    sectionTitle="{{ 'common.classification_types_title' | translate }}"
    listTitle="{{ 'common.classification_types_list_title' | translate }}"
    [numRowsPerPage]="10"
    [titles]="titles"
    [items]="this.svc.types"
    deleteButton="{{ 'common.delete' | translate }}"
    addButton="{{ 'common.add' | translate }}"
    (onAdd)="showAddDialog($event)"
    (onCancelDetail)="this.svc.editing=null"
    [editable]="true"
    (onEditInline)="onEditInline($event)"
    (onDelete)="onDeleteInline($event)"
    [customButtons]="customButtons"
    (onCustomButton)="onCustomButton($event)"
    >
      <app-kv-classification-types-form
        *ngIf="this.svc.editingType"
        [editingElement]="this.svc.editingType"
        (onAddElement)="onAdd($event)"
      >
      </app-kv-classification-types-form>
    </kv-datatable>
  


// WEBPACK FOOTER //
// ./src/app/views/administration/classification/classification-types.component.ts.ClassificationTypes2Component.html